import { FiBriefcase, FiUser } from "react-icons/fi";
import { APPLICANT_TYPES } from "../../constants/kyc";

const ICONS = { individual: FiUser, company: FiBriefcase };

/**
 * Who a business is registered to: an individual or a company. It decides which form
 * follows — an individual answers the highlighted part of Keepz's form, a company all
 * of it. Nothing is preselected.
 */
export default function ApplicantTypePicker({ value, onChange, error, disabled, isDark, t }) {
  return (
    <div>
      {/* Side by side when the form is wide enough, stacked when it isn't — the form's
          width, not the window's, since the create page squeezes it between panels. */}
      <div
        role="radiogroup"
        aria-label={t("kyc.applicant.title")}
        className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,15rem),1fr))] gap-3"
      >
        {APPLICANT_TYPES.map((id) => {
          const Icon = ICONS[id];
          const selected = value === id;
          return (
            <button
              key={id}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange(id)}
              className={`group flex items-start gap-3 rounded-radius-md border p-4 text-left transition disabled:cursor-not-allowed ${
                selected
                  ? "border-accent-default bg-accent-tinted shadow-md"
                  : error
                  ? "border-status-danger"
                  : isDark
                  ? "border-white/10 bg-white/[0.03] hover:border-white/20 hover:bg-white/[0.06]"
                  : "border-slate-200 bg-white hover:border-accent-default hover:shadow-sm"
              } ${disabled && !selected ? "opacity-50" : ""}`}
            >
              <span
                className={`grid size-10 shrink-0 place-items-center rounded-radius-sm transition ${
                  selected
                    ? "bg-accent-default text-accent-on"
                    : isDark
                    ? "bg-white/10 text-slate-300 group-hover:text-accent-text"
                    : "bg-slate-100 text-slate-600 group-hover:text-status-success"
                }`}
              >
                <Icon className="h-5 w-5" />
              </span>
              <span className="min-w-0 flex-1">
                <span className={`block text-subheadline-semibold text-label-primary`}>
                  {t(`kyc.applicantTypes.${id}`)}
                </span>
                <span className={`mt-1 block text-footnote leading-snug text-label-secondary`}>
                  {t(`kyc.applicant.${id}Hint`)}
                </span>
              </span>
              <span
                className={`mt-0.5 grid size-4 shrink-0 place-items-center rounded-full border ${
                  selected ? "border-accent-default bg-accent-default" : "border-separator-opaque"
                }`}
                aria-hidden
              >
                {selected && <span className="size-1.5 rounded-full bg-ink" />}
              </span>
            </button>
          );
        })}
      </div>
      {error && (
        <p className="mt-1.5 text-footnote text-status-danger" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
